// This is used by the various question types to reduce the amount of code that is being reused

import questionheader from "@/components/QuestionHeader";
import questionfooter from "@/components/QuestionFooter";
import validationpopup from "@/components/ValidationPopup";
import questioninput from "@/components/QuestionInput";
import answerlabel from "@/components/AnswerLabel";
import answerdescription from "@/components/AnswerDescription";
import checkboxradio from "@/components/CheckboxRadio";
import media from "@/components/Media";

export default {
    // All the default Vue functionalities that all questions share
    defaultQuestion: {
        props: {
            questionIndex: {
                type: Number,
            },
        },
        components: {
            questionheader,
            questionfooter,
            answerdescription,
            checkboxradio,
            validationpopup,
            media,
            questioninput,
            answerlabel
        },
        methods: {
            submitQuestion: function (e) {
                const interactiveControl = e.target.closest(`a[href], button, select, audio, video, iframe, [data-answer-label], [role="button"], [role="link"], [role="option"], [role="radio"], [role="slider"], [role="listbox"], [contenteditable="true"], [draggable="true"]`);
                const enterIsUsedByInput = [`date`, `file`, `number`, `range`].includes(e.target.getAttribute(`type`))
                    || e.target.tagName === `TEXTAREA`;

                // Interactive controls use Enter for their own action and must not submit the question.
                if (interactiveControl || enterIsUsedByInput) return;

                // When using countdown go the next button is disabled and we dont want to submit until its enabled.
                if(document.querySelector("#button-next-nav").disabled === true) return;

                // reset focus to trigger the validation
                e.target.blur();
                e.target.focus();

                this.$store.dispatch(`nextButtonClicked`);
            },
        },
        mounted: function () {
            // Reset the validity of the form
            this.$store.commit(`changeGlobal`, {
                variableName: `formIsValid`,
                newValue: true,
            });

            // Trigger the validation of the question so everything is reset again when a new question is loaded
            this.questionIsValid;

            const focusInput = document.querySelector('[focus-input]');
           
            if (focusInput) {
                focusInput.focus();
            }
            else {
                const focusables = document.querySelectorAll(
                    'button, a, input, select, textarea, [tabindex]:not([tabindex="-1"])'
                );

                if (focusables.length) {
                    focusables[0].focus();
                }
            }
        },
        created: function () {
            this.$store.dispatch(`pageStartAtTop`);
            this.$store.commit(`changeGlobal`, {
                variableName: `showLoader`,
                newValue: false,
            });
        },
        computed: {
            state: function () {
                return this.$store.state;
            },
            questionData: function () {
                return this.state.page.questions[this.questionIndex];
            },
            // Validation messages that come from the backend
            questionMessage() {
                if (this.state.message === undefined) return [];

                return this.state.message.filter((message) => {
                    return message.questionId === this.questionData.id && message.answerId === null;
                });
            },
            // The validation restrictions of this question. Like how many checkboxes should be selected
            restrictions: function () {
                return this.questionData.validation;
            },
            settings: function () {
                return this.state.settings;
            },
            get: function () {
                return this.$store.getters;
            },
            validationNone: function () {
                let validity;
                let required = this.restrictions.required;
                let subQuestions = this.questionData.subQuestions;
                
                // Drag and drop works differently..
                if(this.questionData.type === `DragAndDrop`) {
                    // If required is false, this will always be valid
                    // If the amount of given answers is equal to the amount of answers per subquestion the question is valid
                    validity = required === false || this.answersGiven === subQuestions[0].answers.length;
                }
                else if (subQuestions) {
                    // If required is false, this will always be valid
                    // If the amount of given answers is equal to the amount of subquestions the question is valid
                    validity = required === false || this.answersGiven === subQuestions.length;
                } else {
                    // If required is false, this will always be valid
                    // If the amount of given answers is higher than 0 it will always be valid
                    validity = required === false || this.answersGiven > 0;
                }

                return [{ validationType: `none`, isValid: validity }];
            },
            validationMinValue: function () {
                let minValue = this.restrictions.minValue;
                let isValid = this.answersGiven >= minValue || minValue === -1;

                if(minValue === -1) return []; // Rules with -1 should never be shown as they are always valid

                return [{ validationType: `minValue`, value: minValue, isValid: isValid }];
            },
            validationMaxValue: function () {
                let maxValue = this.restrictions.maxValue;
                let isValid = this.answersGiven <= maxValue || maxValue === -1;

                if(maxValue === -1) return []; // Rules with -1 should never be shown as they are always valid

                return [{ validationType: `maxValue`, value: maxValue, isValid: isValid }];
            },
            validationRange: function () {
                // We need both the MinValue and MaxValue validation in this case
                return this.validationMinValue.concat(this.validationMaxValue);
            },
            validationExactValue: function () {
                // We need both the MinValue and MaxValue validation in this case
                return this.validationMinValue.concat(this.validationMaxValue);
            },
            // Is question valid, returns a boolean
            questionIsValid: function () {
                let validationRules = this.questionValidation;
                
                if(this.customValidation) validationRules = validationRules.concat(this.customValidation);

                let allValidationIsValid = validationRules.every(r => r.isValid);
                this.questionData.isValid = allValidationIsValid;
                
                return allValidationIsValid;
            },
            // Return the validation rules and whether they are true or not
            questionValidation: function () {
                // Trigger the questionIsValid property when the calculcations below are finished
                setTimeout(() => {
                    this.questionIsValid;
                });
                
                // Register customValidation so that this computed property will be updated when the customValidation is updated
                if(this.customValidation) this.customValidation;
                
                return this[`validation${this.restrictions.validationType}`];
            }
        },
    },
};
